<template>
  <div class="pb-1">
    <label class="font-weight-medium">
      <slot></slot>
      &nbsp;
      <span v-if="required">*</span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    required: { type: Boolean, required: true }
  }
}
</script>
